import type { PatternsFieldType, TranslationsKeys } from '@wix/bex-core';

/**
 * The add-field modal's standard name and name-input placeholder per creatable
 * field type, used when a source declares a type without a custom label.
 * NUMBER uses the integer variant's copy.
 */
export const standardFieldTypeLabels: Partial<
  Record<
    PatternsFieldType,
    { labelKey: TranslationsKeys; namePlaceholderKey: TranslationsKeys }
  >
> = {
  SHORT_TEXT: {
    labelKey: 'cairo.customFields.fieldType.shortText',
    namePlaceholderKey:
      'cairo.customFields.fieldType.shortText.Name.placeholder',
  },
  LONG_TEXT: {
    labelKey: 'cairo.customFields.fieldType.longText',
    namePlaceholderKey:
      'cairo.customFields.fieldType.longText.Name.placeholder',
  },
  NUMBER: {
    labelKey: 'cairo.customFields.fieldType.numberInteger',
    namePlaceholderKey:
      'cairo.customFields.fieldType.numberInteger.Name.placeholder',
  },
  BOOLEAN: {
    labelKey: 'cairo.customFields.fieldType.checkbox',
    namePlaceholderKey:
      'cairo.customFields.fieldType.checkbox.Name.placeholder',
  },
  DATE: {
    labelKey: 'cairo.customFields.fieldType.date',
    namePlaceholderKey: 'cairo.customFields.fieldType.date.Name.placeholder',
  },
  DATETIME: {
    labelKey: 'cairo.customFields.fieldType.dateAndTime',
    namePlaceholderKey:
      'cairo.customFields.fieldType.dateAndTime.Name.placeholder',
  },
  URL: {
    labelKey: 'cairo.customFields.fieldType.url',
    namePlaceholderKey: 'cairo.customFields.placeholder.url',
  },
};
